import { render, staticRenderFns } from "./RecentPowerlearningCategories.vue?vue&type=template&id=d1a085ee&scoped=true"
import script from "./RecentPowerlearningCategories.vue?vue&type=script&lang=js"
export * from "./RecentPowerlearningCategories.vue?vue&type=script&lang=js"
import style0 from "./RecentPowerlearningCategories.vue?vue&type=style&index=0&id=d1a085ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a085ee",
  null
  
)

export default component.exports